import { getRgObjectsOfType as d, RG_TYPE as u } from "@project-rouge/rg-core";
const g = (e) => {
  const t = d(e, u.Building).map((l) => s(l));
  return Math.max(0, ...t);
};
function s(e) {
  return e.data.levels.filter((o) => o.isPodium).map((o) => m(e, o)).reduce((o, n) => o + n, 0);
}
function m(e, i) {
  const t = e.data.levels.find((l) => l.levelIndex === i.levelIndex + 1);
  return t ? t.floorWorldBottom - i.floorWorldBottom : 0;
}
export {
  g as getPodiumHeightSum
};
//# sourceMappingURL=index42.js.map
